export enum LastActionPerformed {
    SearchPressed,
    SearchResultIteration,
    ItemPartExpanded
}
